import { SIZE_THUMBNAIL_OPTIONS } from '@/shared/model';

export const ECG_DISCLOSURE = 'ECG_DISCLOSURE';
export const AUTO_EVENTS = 'AUTO_EVENTS';

export const DEVICE_EVENT_TAB_ENUM = {
  NOTIFICATION: 'notificationEvents',
  PATIENT_TRIGGERED: 'patientTriggeredEvents',
  OTHER: 'otherEvents',
};

export const DEVICE_TAB_TYPES = [
  DEVICE_EVENT_TAB_ENUM.NOTIFICATION,
  DEVICE_EVENT_TAB_ENUM.PATIENT_TRIGGERED,
  DEVICE_EVENT_TAB_ENUM.OTHER,
];

export const AUTO_EVENT_TAB_ENUM = {
  OTHER: 'OTHER',
  VE: 'VE',
  SVE: 'SVE',
  AFIB: 'AFIB',
  TACHY: 'TACHY',
  BRADY: 'BRADY',
  PAUSE: 'PAUSE',
  VT: 'VT',
  SVT: 'SVT',
  MIN_HR: 'MIN_HR',
  MAX_HR: 'MAX_HR',
  HB: 'HB',
};

export const SIZE_STRIP_MANAGEMENT_THUMBNAIL = {
  [SIZE_THUMBNAIL_OPTIONS.SMALL]: {
    name: SIZE_THUMBNAIL_OPTIONS.SMALL,
    width: 532,
    height: 206.98,
    imageWidth: 516,
    imageHeight: 153.98,
    textWidth: 382,
    commentWidth: 514,
  },
  [SIZE_THUMBNAIL_OPTIONS.MEDIUM]: {
    name: SIZE_THUMBNAIL_OPTIONS.MEDIUM,
    width: 650,
    height: 242.19,
    imageWidth: 634,
    imageHeight: 189.19,
    textWidth: 500,
    commentWidth: 632,
  },
  [SIZE_THUMBNAIL_OPTIONS.LARGE]: {
    name: SIZE_THUMBNAIL_OPTIONS.LARGE,
    width: 750,
    height: 272.03,
    imageWidth: 734,
    imageHeight: 219.03,
    textWidth: 600,
    commentWidth: 732,
  },
};

export const SIZE_DEVICE_STRIP_MANAGEMENT_THUMBNAIL = {
  [SIZE_THUMBNAIL_OPTIONS.SMALL]: {
    name: SIZE_THUMBNAIL_OPTIONS.SMALL,
    width: 532,
    height: 189.51,
    imageWidth: 516,
    imageHeight: 136.51,
    textWidth: 382,
    commentWidth: 514,
  },
  [SIZE_THUMBNAIL_OPTIONS.MEDIUM]: {
    name: SIZE_THUMBNAIL_OPTIONS.MEDIUM,
    width: 650,
    height: 220.72,
    imageWidth: 634,
    imageHeight: 167.72,
    textWidth: 500,
    commentWidth: 632,
  },
  [SIZE_THUMBNAIL_OPTIONS.LARGE]: {
    name: SIZE_THUMBNAIL_OPTIONS.LARGE,
    width: 750,
    height: 246.18,
    imageWidth: 734,
    imageHeight: 194.18,
    textWidth: 600,
    commentWidth: 732,
  },
};

export const AI_EVENTS_STATUS = {
  EDITED: 'Edited',
  REMOVED: 'Removed',
};
